<script setup lang="ts">
import { useNavigation } from "~/composables/use-navigation";

const { route } = useNavigation();
</script>

<template>
  <NuxtPage v-bind="route.params" />
</template>
